import type { TelstraMobileReport } from '../services/telstraService';

/** Selects the Excel report from a recurring-task attachment set. */
export function findBlitzAttachment<T extends { fileName: string }>(
  attachments: readonly T[],
): T | undefined {
  return attachments.find((attachment) => attachment.fileName.toLowerCase().endsWith('.xlsx'));
}

/**
 * Returns true when a parsed Telstra blitz report has $0 totals across the
 * board — typically a sign that the bill hasn't been generated yet and the
 * report should not be approved/shared with the customer.
 *
 * Shared between the manual upload flow in Telstra.tsx and the recurring
 * task approval flow in BlitzReportApprovalAction.
 */
export function isZeroBillReport(r: TelstraMobileReport | null | undefined): boolean {
  if (!r || !r.rows || r.rows.length === 0) return false;
  const totalZero = (r.totals?.totalLatestMonthBills ?? 0) === 0;
  const allRowsZero = r.rows.every(row => (row.latestMonthBillTotal ?? 0) === 0);
  return totalZero && allRowsZero;
}
